import { render, staticRenderFns } from "./SlelectObservationPoint.vue?vue&type=template&id=3850b944&"
import script from "./SlelectObservationPoint.vue?vue&type=script&lang=ts&"
export * from "./SlelectObservationPoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports